import { Component, OnInit, Input } from '@angular/core';

import { ConstantsService } from 'app/services/constants-service';

import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { EntitySurveysService } from 'app/entities/surveys/entity-surveys.service';
import { SurveyInstance } from 'app/entities/surveys/survey-instance.model';

@Component({
  selector: 'surveylist',
  templateUrl: './survey-list.component.html',
  styleUrls: ['./survey-list.component.css']
})
export class SurveyListComponent implements OnInit {
  @Input() entityIdDetails: EntityIdDetails;
  surveyInstances: SurveyInstance[];
  isLoading = false;
  constructor(private entitySurveysService: EntitySurveysService) { }

  ngOnInit() {
    this.isLoading = true;
    this.entitySurveysService.getSurveyDetails(this.entityIdDetails.entityId)
      .subscribe(response => {
        this.surveyInstances = response;
        this.isLoading = true;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/surveys/surveylist/survey-list.component.ts